import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from '@atoms';

export const ToggleArrow = ({ expanded, toggle }) => (
  <Button invisible onClick={toggle} style={{ width: '14px', height: '14px' }}>
    <Icon name={expanded ? 'triangleExpanded' : 'triangleCollapsed'} />
  </Button>
);

ToggleArrow.propTypes = {
  expanded: PropTypes.bool,
  toggle: PropTypes.func,
};



// WEBPACK FOOTER //
// ./components/molecules/ToggleArrow/ToggleArrow.js